import "./MoveableDialog.css";

// this script makes the Zenya dialog (and other vuetify dialogs) movable
interface DragData {
    el?: HTMLElement;
    mouseStartX?: number;
    mouseStartY?: number;
    elStartX?: number;
    elStartY?: number;
    oldTransition?: string;
}

(function () {
    // make vuetify dialogs movable
    const d: DragData = {};
    document.addEventListener("mousedown", function (e: MouseEvent) {
        const eventTarget: HTMLElement = e.target as HTMLElement;

        let closestDialog: HTMLElement;
        if (typeof eventTarget.closest === "function") {
            closestDialog = eventTarget.closest(".v-dialog.v-dialog--active");
        }
        if (
            e.button === 0 &&
            closestDialog != null &&
            (eventTarget.classList.contains("v-card__title") || eventTarget.classList.contains("dialogTitleText"))
        ) {
            // element which can be used to move element
            d.el = closestDialog; // element which should be moved
            d.mouseStartX = e.clientX;
            d.mouseStartY = e.clientY;
            d.elStartX = d.el.getBoundingClientRect().left;
            d.elStartY = d.el.getBoundingClientRect().top;
            d.el.style.position = "fixed";
            d.el.style.margin = "0";
            d.oldTransition = d.el.style.transition;
            d.el.style.transition = "none";
            d.el.classList.add("dragging");
        }
    });
    document.addEventListener("mousemove", function (e) {
        if (d.el === undefined) return;
        d.el.style.left =
            Math.min(Math.max(d.elStartX + e.clientX - d.mouseStartX, 0), window.innerWidth - d.el.getBoundingClientRect().width) + "px";
        d.el.style.top =
            Math.min(Math.max(d.elStartY + e.clientY - d.mouseStartY, 0), window.innerHeight - d.el.getBoundingClientRect().height) + "px";
    });
    document.addEventListener("mouseup", () => {
        if (d.el === undefined) return;
        d.el.style.transition = d.oldTransition;
        d.el.classList.remove("dragging");
        d.el = undefined;
    });
})();
